import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Output, Renderer2, TemplateRef, ViewChild} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {DialogGetAssetComponent, IDialogGetAsset} from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import {SceneMimeTypes} from "../mime-constants";
import {IPager} from "../../../../interfaces";
import {ITablesSelectorSet} from "../../../../components/tables-selector/tables-selector.component";
import {IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ITableListColumn, ITableListEvent} from "../../../../components/table-list-input/table-list-input.component";
import {actionSceneItemLocation} from "../../../../store/actions/user.actions";
import {isNullOrUndefined} from "util";
import {timeout} from "../../../../decorators/timeout";
import {ContainerService, StoreSelectorsService} from "../../../../services";
import {ToastrService} from "ngx-toastr";
import {map, take} from 'rxjs/operators';
import {Observable} from "rxjs";
import {Lib} from "../../../../../libs/Lib";
import * as _ from 'lodash';

@Component({
    selector: 'app-scene-block-location',
    templateUrl: './block-location.component.html',
    styleUrls: ['./block-location.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class BlockLocationComponent extends BlockBaseComponent {
    buttonsGps: IButtonBar[] = [];
    buttonsFixed: IButtonBar[] = [];
    tableColumnsFixed: Array<ITableListColumn> = [];
    tableColumnsGps: Array<ITableListColumn> = [];
    formSettings: FormGroup;
    coords: Array<number>;
    style;
    once;
    containerServiceMode: string;

    @Output() changed: EventEmitter<ITablesSelectorSet> = new EventEmitter();
    @ViewChild('tab1', {read: ElementRef}) tab1;
    @ViewChild('tab2', {read: ElementRef}) tab2;
    @ViewChild("locationPageModal", {read: TemplateRef}) locationPageModal: TemplateRef<any>;

    constructor(private formBuilder: FormBuilder,
                private el: ElementRef, private render: Renderer2,
                private containerService: ContainerService,
                private translocoService: TranslocoService,
                public override storeSelector: StoreSelectorsService,
                private toastr: ToastrService,
                public override dialog: MatDialog, public cd: ChangeDetectorRef
    ) {
        super(storeSelector, dialog);
        this.initButtons();
        this.initForm();
        this.cod(
            this.storeSelector.listenSelectedSceneLocationCoords()
                .subscribe((coords) => {
                    this.coords = coords;
                })
        );
    }

    initButtons() {
        this.tableColumnsFixed = [{
            inputType: 'edit',
            name: 'page',
            maxStringSize: '16'
        }, {
            inputType: 'text',
            name: 'type',
            maxStringSize: '16'
        }
            /** example of dropdown select **/
            // , {
            //     inputType: 'select',
            //     name: 'type',
            //     maxStringSize: '16',
            //     selectValues: ['1', '2', '3'],
            //     selectValue: '2'
            // }
        ];

        this.tableColumnsGps = [{
            inputType: 'edit',
            name: 'page',
            maxStringSize: '16'
        }, {
            inputType: 'text',
            name: 'type',
            maxStringSize: '16'
        }];
        this.buttonsGps = [
            {
                callBack: v => (v),
                icon: 'place',
                name: 'place',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.place', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'add_location_alt',
                name: 'coords',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.applyCoords', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'settings',
                name: 'settings',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.settings', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_left',
                name: 'previous',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.next', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_right',
                name: 'next',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.previous', {}, this.translocoService.getActiveLang())
            }
        ];
        this.buttonsFixed = [
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disableByList: true,
                disabled: false
            }
        ];
    }

    initForm() {
        // this.sourceFixed = this.sceneItem.Data[0].LocationBased[0].Fixed[0]?.Page?.length > 0 ? this.sceneItem.Data[0].LocationBased[0].Fixed[0]?.Page : [];
        // this.sourceGps = this.sceneItem.Data[0].LocationBased[0].GPS[0]?.Page?.length > 0 ? this.sceneItem.Data[0].LocationBased[0].GPS[0]?.Page : [];
        this.formSettings = this.formBuilder.group({
            sourceId: [],
            sourceType: [],
            sourceName: [{disabled: true, value: ''}, [Validators.required]],
            page: ['', [Validators.required, Validators.minLength(2)]],
            type: [{disabled: true, value: ''}, [Validators.required]],
            lat: ['', [Validators.required]],
            lng: ['', [Validators.required]],
            duration: ['', [Validators.required]],
            radios: ['', [Validators.required]],
            priority: ['', [Validators.required]]
        });
    }

    @timeout(0)
    repositionDomElements() {
        /**
         moving dynamic form component cheat sheet
         -----------------------------------------
         -- first approach:
         this.renderer.appendChild(this.emptyBox.nativeElement,this.child1.nativeElement);
         -- second approach using class:
         this.renderer.appendChild(this.elRef.nativeElement.querySelector('.empty-box'), this.child1.nativeElement);
         const a = this.el.nativeElement.querySelector('.page-dynamic-class')
         const b = this.el.nativeElement.querySelector('.page-dynamic-class')
         to actually move via construction see: https://stackblitz.com/edit/angular-t3rxb3?file=src%2Fapp%2Fapp.component.html
         **/
        const compRef1 = this.getFormComponentRef('Page');
        if (compRef1) {
            this.render.appendChild(this.tab1.nativeElement, compRef1.componentRef.instance.elementRefs.nativeElement);
        }
        const compRef2 = this.getFormComponentRef('pageGps');
        if (compRef2) {
            this.render.appendChild(this.tab2.nativeElement, compRef2.componentRef.instance.elementRefs.nativeElement);
        }
    }

    override submit(formValues) {
        super.submit(formValues, (values) => {
            return this.swapKeyName(values, 'pageGps', 'Page');
        });
        // if (this.onFormSubmitAction(formValues)) {
        //     super.submit(formValues, (values) => {
        //         return this.swapKeyName(values, 'pageGps', 'Page');
        //     });
        // }
    }

    tabChange(index) {
        if (index === 0 || this.once) return;
        this.once = true;
        this.listenContainerService();
    }

    private onFormSubmitAction(e): boolean {
        let returnVal = null;
        Object.entries(e).map((items: Array<any>) => {
            const tableName = items[0];
            items.forEach((val: ITableListEvent) => {
                if (isNullOrUndefined(val?.currentAction)) return;
                Lib.DevShow(`>>> onFormSubmitAction ${tableName} | ${val.currentAction}| selected ${val.selected.length} | values ${val.values.length}`);
                switch (val.currentAction) {
                    case 'place': {
                        this.containerService.updateEditorMode('locationMode');
                        this.tableListButtonDisable('pageGps', 'previous', false);
                        this.tableListButtonDisable('pageGps', 'next', false);
                        this.tableListButtonDisable('pageGps', 'place', true);
                        return returnVal = false;
                    }
                    case 'next':
                    case 'previous':
                    case 'selected':
                    case 'externallySelected': {
                        return returnVal = false;
                    }
                    case 'drop': {
                        return returnVal = true;
                    }
                    case 'added': {
                        this.openAssociateDialog(true, tableName);
                        this.storeSelector.dispatch(actionSceneItemLocation({indexes: []}));
                        return returnVal = false;
                    }
                    case 'coords': {
                        if (!this.coords || this.coords[0] === 0 || this.coords[1] === 0) {
                            this.toastr.error(this.translocoService.translate('general.firstChooseCoords', {}, this.translocoService.getActiveLang()));
                            return returnVal = false;
                        }
                        this.toastr.info(`${this.coords[0]} , ${this.coords[1]}`);
                        this.toastr.info(this.translocoService.translate('general.appliedCoords', {}, this.translocoService.getActiveLang()));
                        const index = val.selectedIndexes[0];
                        val.values[index].$.lat = this.coords[0];
                        val.values[index].$.lng = this.coords[1];
                        return returnVal = true;
                    }
                    case 'removed': {
                        this.storeSelector.dispatch(actionSceneItemLocation({indexes: []}));
                        return returnVal = true;
                    }
                    case 'rename': {
                        return returnVal = true;
                    }
                    case 'settings': {
                        if (val.selected["0"].$.type === 'resource') {
                            this.cod(
                                this.storeSelector.getResource(val.selected["0"].Player["0"].Data["0"].Resource["0"].$.resource)
                                    .pipe(take(1))
                                    .subscribe((resource) => {
                                        this.openLocalGpsSettings(val, resource?.resource_name, 'RESOURCE_SELECTED', val.selectedIndexes[0]);
                                    })
                            );
                        } else if (val.selected["0"].$.type === 'scene') {
                            this.cod(
                                this.storeSelector.getScene(val.selected[0]?.Player[0]?.$?.src)
                                    .pipe(take(1))
                                    .subscribe((scene) => {
                                        this.openLocalGpsSettings(val, scene?.Player?.$?.label, 'SCENE_SELECTED', val.selectedIndexes[0]);
                                    })
                            );
                        }
                        return returnVal = false;
                    }
                    default: {
                        return returnVal = true;
                    }
                }
            });
        });
        this.cd.markForCheck();
        return returnVal;
    }

    override componentInit() {
        super.componentInit();
        this.repositionDomElements();
    }

    override componentStoreUpdates() {
        // const sourceFixed = this.sceneItem.Data[0].LocationBased[0].Fixed[0]?.Page?.length > 0 ? this.sceneItem.Data[0].LocationBased[0].Fixed[0]?.Page : [];
        // const sourceGps = this.sceneItem.Data[0].LocationBased[0].GPS[0]?.Page?.length > 0 ? this.sceneItem.Data[0].LocationBased[0].GPS[0]?.Page : [];
        /** only if scene id is new i.e. we switched to a new Location component  / block id do we re-move the DOM elements  **/
        if (this.sceneItemSwitched) this.repositionDomElements();
        if (this.containerServiceMode === 'locationMode') this.applyStoreToDynamic();
        // super.componentStoreUpdates();
        // this.applyStoreToDynamic();
        this.cd.markForCheck();
    }

    applyStoreToDynamic() {
        super.initApplyStoreToDynamic(true);
    }

    listenContainerService() {
        this.cod(
            this.containerService.editorMode.subscribe((v) => {
                this.containerServiceMode = v;
                if (v === 'locationMode') {
                    this.tableListButtonDisable('pageGps', 'previous', false);
                    this.tableListButtonDisable('pageGps', 'next', false);
                    this.tableListButtonDisable('pageGps', 'place', true);
                } else {
                    this.tableListButtonDisable('pageGps', 'previous', true);
                    this.tableListButtonDisable('pageGps', 'next', true);
                    this.tableListButtonDisable('pageGps', 'place', false);
                }
            })
        );
    }

    openLocalGpsSettings(tableListItem: ITableListEvent, name: string, type: 'RESOURCE_SELECTED' | 'SCENE_SELECTED', selectedIndex: number) {
        const sourceId = type === 'SCENE_SELECTED' ? this.sceneItem.Data["0"].LocationBased["0"].GPS["0"].Page[selectedIndex].Player[0].$.src : this.sceneItem.Data["0"].LocationBased["0"].GPS["0"].Page[selectedIndex].Player[0].Data[0].Resource[0].$.resource;
        this.formSettings.get('sourceId').setValue(sourceId);
        this.formSettings.get('sourceName').setValue(name);
        this.formSettings.get('sourceType').setValue(type);
        this.formSettings.get('page').setValue(this.sceneItem.Data["0"].LocationBased["0"].GPS["0"].Page[selectedIndex].$.page);
        this.formSettings.get('type').setValue(this.sceneItem.Data["0"].LocationBased["0"].GPS["0"].Page[selectedIndex].$.type);
        this.formSettings.get('lat').setValue(this.sceneItem.Data["0"].LocationBased["0"].GPS["0"].Page[selectedIndex].$.lat);
        this.formSettings.get('lng').setValue(this.sceneItem.Data["0"].LocationBased["0"].GPS["0"].Page[selectedIndex].$.lng);
        this.formSettings.get('radios').setValue(this.sceneItem.Data["0"].LocationBased["0"].GPS["0"].Page[selectedIndex].$.radios);
        this.formSettings.get('duration').setValue(this.sceneItem.Data["0"].LocationBased["0"].GPS["0"].Page[selectedIndex].$.duration);
        this.formSettings.get('priority').setValue(this.sceneItem.Data["0"].LocationBased["0"].GPS["0"].Page[selectedIndex].$.priority);
        const dialogRef = this.dialog.open(this.locationPageModal, {width: '400px'});
        this.cod(
            dialogRef.afterClosed()
                .pipe(take(1))
                .subscribe(result => {
                    const page: IPager = tableListItem.values[selectedIndex];
                    page.$.page = this.formSettings.get('page').value ? this.formSettings.get('page').value : '';
                    page.$.radios = this.formSettings.get('radios').value ? this.formSettings.get('radios').value : 0;
                    page.$.priority = this.formSettings.get('priority').value ? this.formSettings.get('priority').value : 0;
                    page.$.duration = this.formSettings.get('duration').value ? this.formSettings.get('duration').value : 0;
                    page.$.lng = this.formSettings.get('lng').value ? this.formSettings.get('lng').value : 0;
                    page.$.lat = this.formSettings.get('lat').value ? this.formSettings.get('lat').value : 0;
                    const selectedType = this.formSettings.get('sourceType').value;
                    switch (selectedType) {
                        case "SCENE_SELECTED": {
                            try {
                                delete page.Player[0].Data[0].Resource[0].$.resource;
                            } catch (e) {
                            }
                            page.$.type = 'scene';
                            _.set(tableListItem.values[selectedIndex].Player[0], '$.src', this.formSettings.controls['sourceId'].value);
                            break;
                        }
                        case "RESOURCE_SELECTED": {
                            try {
                                delete page.Player[0].$.src;
                            } catch (e) {
                            }
                            page.$.type = 'resource';
                            _.set(tableListItem.values[selectedIndex].Player[0], 'Data["0"].Resource["0"].$.resource', this.formSettings.controls['sourceId'].value);
                            break;
                        }
                    }
                    this.storeSelector.dispatch(actionSceneItemLocation({indexes: null}));
                    this.dispatchLocation(tableListItem);
                    this.applyStoreToDynamic();
                })
        );
    }

    dispatchLocation(tableListItem: ITableListEvent) {
        const value = tableListItem.values;
        value.forEach((v) => {
            delete v.$.sourceId;
            delete v.$.sourceType;
        });
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Page',
                value,
                storePath: 'Data[0].LocationBased[0].GPS[0]'
            }]
        });
    }

    openAssociateDialog(addingNew, tableName: 'pageGps' | 'Page') {
        const data: IDialogGetAsset = {mode: "SCENE_RESOURCE:PLAYER", mimeType: SceneMimeTypes.Player, multiSelect: true};
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            width: '70%',
            panelClass: 'custom-dlg-container',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .subscribe((dialogGetAssets: IDialogGetAsset[]) => {
                    if (!dialogGetAssets || !Array.isArray(dialogGetAssets)) return;

                    dialogGetAssets.forEach((dialogGetAsset: IDialogGetAsset) => {
                        if (addingNew) {
                            this.addTableItem(tableName, dialogGetAsset);
                        } else {
                            switch (dialogGetAsset.selectedType) {
                                case "SCENE_SELECTED": {
                                    this.formSettings.get('sourceName').setValue(dialogGetAsset.sourceData.Player.$.label);
                                    this.formSettings.get('sourceId').setValue(dialogGetAsset.selected);
                                    this.formSettings.get('sourceType').setValue('SCENE_SELECTED');
                                    this.formSettings.get('type').setValue('scene');
                                    break;
                                }
                                case "RESOURCE_SELECTED": {
                                    this.formSettings.get('sourceName').setValue(dialogGetAsset.sourceData.resource_name);
                                    this.formSettings.get('sourceId').setValue(dialogGetAsset.selected);
                                    this.formSettings.get('sourceType').setValue('RESOURCE_SELECTED');
                                    this.formSettings.get('type').setValue('resource');
                                    break;
                                }
                            }
                        }
                    });
                })
        );
    }

    addTableItem(tableName: 'Page' | 'pageGps', dialogGetAsset: IDialogGetAsset) {
        let storePath;
        let pager: IPager;
        let pages: Array<IPager> = [];
        const locationBased = this.sceneItem.Data["0"].LocationBased;

        switch (tableName) {
            case 'Page': {
                storePath = 'Data[0].LocationBased[0].Fixed[0]';
                if (locationBased && locationBased["0"]?.Fixed && locationBased["0"].Fixed["0"]?.Page) {
                    pages = _.cloneDeep(locationBased["0"].Fixed["0"].Page);
                }
                break;
            }
            case 'pageGps': {
                storePath = 'Data[0].LocationBased[0].GPS[0]';
                if (locationBased && locationBased["0"]?.GPS && locationBased["0"].GPS["0"]?.Page) {
                    pages = _.cloneDeep(locationBased["0"].GPS["0"].Page);
                }
                break;
            }
        }
        switch (dialogGetAsset.selectedType) {
            case "RESOURCE_SELECTED": {
                const resource_type = dialogGetAsset.sourceData.resource_type;
                const playerId = (["mp4", "mov", "m4v", "3gp"].indexOf(resource_type) > -1) ? "3100" : "3130";

                pager = {
                    $: {
                        page: `${dialogGetAsset.sourceData.resource_name}`,
                        type: "resource",
                        lat: '34',
                        lng: '-118',
                        radios: '20',
                        priority: '5',
                        duration: '5'
                    },
                    Player: [
                        {
                            "$": {
                                player: playerId,
                                id: _.uniqueId('__')
                            },
                            Data: [
                                {
                                    Resource: [
                                        {
                                            $: {
                                                resource: dialogGetAsset.selected
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                };
                break;
            }
            case "SCENE_SELECTED": {
                pager = {
                    $: {
                        page: dialogGetAsset.sourceData.Player.$.label,
                        type: "scene",
                        lat: '34',
                        lng: '-118',
                        radios: '20',
                        priority: '5',
                        duration: '5'
                    },
                    Player: [
                        {
                            $: {
                                src: dialogGetAsset.selected
                            }
                        }
                    ]
                };
                break;
            }
        }
        pages.push(pager);
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Page',
                value: pages,
                storePath
            }]
        });
        this.applyStoreToDynamic();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                label: '',
                inputType: 'tablelist',
                tableColumns: this.tableColumnsFixed,
                confirmRemove: false,
                buttons: this.buttonsFixed,
                inputEditFormat: {page: 'text'},
                inputEditRenamePath: [{path: '$.page', key: 'page'}, {path: '$.type', key: 'type'}],
                name: "Page",
                cloneVals: true,
                ignoreMissingValue: true,
                expandableEditor: true,
                enablePagination: true,
                disableSubmit: true,
                allowFilter: true,
                storePath: 'Data[0].LocationBased[0].Fixed[0].Page',
                callBackEvent: (v) => this.callBackEvents(v, 'Page')
            },
            {
                type: "input",
                label: '',
                inputType: 'tablelist',
                tableColumns: this.tableColumnsGps,
                ignoreMissingValue: true,
                cloneVals: true,
                buttonBarClassName: 'locationButtonBar',
                buttons: this.buttonsGps,
                rememberSelection: true,
                multiSelect: false,
                expandableEditor: true,
                enablePagination: true,
                disableSubmit: true,
                allowFilter: true,
                inputEditFormat: {page: 'text'},
                inputEditRenamePath: [{path: '$.page', key: 'page'}, {path: '$.type', key: 'type'}],
                name: "pageGps",
                storePath: 'Data[0].LocationBased[0].GPS[0].Page',
                callBackEvent: (v) => this.callBackEvents(v, 'pageGps')
            },
            {
                type: "input",
                value: '5',
                label: this.translocoService.translate('general.duration', {}, this.translocoService.getActiveLang()),
                inputType: "number",
                name: "duration",
                storePath: 'Data[0].LocationBased[0].$.duration'
            },
            // ,{
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // }
        ];
    }


    callBackEvents(v: ITableListEvent, tableName: 'Page' | 'pageGps') {
        switch (v.currentAction) {
            case 'place': {
                this.containerService.updateEditorMode('locationMode');
                this.tableListButtonDisable('pageGps', 'previous', false);
                this.tableListButtonDisable('pageGps', 'next', false);
                this.tableListButtonDisable('pageGps', 'place', true);
                break;
            }
            case 'selected': {
                this.storeSelector.dispatch(actionSceneItemLocation({indexes: v.selectedIndexes}));
                break;
            }
            case 'added': {
                this.openAssociateDialog(true, tableName);
                this.storeSelector.dispatch(actionSceneItemLocation({indexes: []}));
                break;
            }
            case 'settings': {
                if (v.selected["0"].$.type === 'resource') {
                    this.cod(
                        this.storeSelector.getResource(v.selected["0"].Player["0"].Data["0"].Resource["0"].$.resource)
                            .pipe(take(1))
                            .subscribe((resource) => {
                                this.openLocalGpsSettings(v, resource?.resource_name, 'RESOURCE_SELECTED', v.selectedIndexes[0]);
                            })
                    );
                } else if (v.selected["0"].$.type === 'scene') {
                    this.cod(
                        this.storeSelector.getScene(v.selected[0]?.Player[0]?.$?.src)
                            .pipe(take(1))
                            .subscribe((scene) => {
                                this.openLocalGpsSettings(v, scene?.Player?.$?.label, 'SCENE_SELECTED', v.selectedIndexes[0]);
                            })
                    );
                }
                break;
            }
            case 'coords': {
                if (!this.coords || this.coords[0] === 0 || this.coords[1] === 0) {
                    this.toastr.error(this.translocoService.translate('general.firstChooseCoords', {}, this.translocoService.getActiveLang()));
                    break;
                }
                this.toastr.info(`${this.coords[0]} , ${this.coords[1]}`);
                this.toastr.info(this.translocoService.translate('general.appliedCoords', {}, this.translocoService.getActiveLang()));
                const index = v.selectedIndexes[0];
                v.values[index].$.lat = this.coords[0];
                v.values[index].$.lng = this.coords[1];
                break;
            }
            case 'rename':
            case 'removed':
            case 'drop': {
                const newPages = v.values;
                if (newPages && _.isArray(newPages)) {

                    const storePath = tableName == 'Page' ? 'Data[0].LocationBased[0].Fixed[0]' : 'Data[0].LocationBased[0].GPS[0]';
                    this.dispatchSceneItemChanges({
                        sceneId: this.sceneId,
                        sceneItemId: this.sceneItem.$.id,
                        values: [{
                            key: 'Page',
                            value: newPages,
                            storePath
                        }]
                    });
                }
                if (v.currentAction === 'removed') {
                    this.storeSelector.dispatch(actionSceneItemLocation({indexes: []}));
                }
                break;
            }
            default: {
                break;
            }
        }

        // if (v.currentAction === 'selected') {
        //     this.storeSelector.dispatch(actionSceneItemLocation({ indexes: v.selectedIndexes }));
        // } else if (v.currentAction === 'previous' || v.currentAction === 'next') {
        //     // this.storeSelector.dispatch(actionSceneItemPlaylist({indexes: e.selectedIndexes}));
        // } else if (v.currentAction === 'rename' || v.currentAction === 'drop') {
        //     const newPages = v.values;
        //     if (newPages && _.isArray(newPages)) {

        //         const storePath = tableName == 'Page' ? 'Data[0].LocationBased[0].Fixed[0]' : 'Data[0].LocationBased[0].GPS[0]';
        //         this.dispatchSceneItemChanges({
        //             sceneId: this.sceneId,
        //             sceneItemId: this.sceneItem.$.id,
        //             values: [{
        //                 key: 'Page',
        //                 value: newPages,
        //                 storePath
        //             }]
        //         });
        //     }
        // }
    }

    /* example of using async pipe and avoid anti pattern: https://stackoverflow.com/questions/62089632/getting-rxjs-value-in-sync-is-this-an-anti-pattern
  
    <td mat-cell *matCellDef="let element">
        {{getAssetNameAsync$(element) | async}}
    </td>
    ...
    you will need to make this onPush to avoid many calls and manually call: this.cd.markForCheck();
    */
    getAssetNameAsync$(i_page: IPager): Observable<string> {
        return (i_page.Player[0].$.src)
            ?
            this.storeSelector.getScene(i_page.Player[0].$.src).pipe(
                map(x => x.Player.$.label))
            :
            this.storeSelector.getResource(i_page.Player[0].Data[0].Resource[0].$.resource).pipe(
                map(x => x.resource_name),
                take(1));
    }
}

